import { Badge } from '@@/Badge';

export function UnusedBadge() {
  return <Badge type="warn">Unused</Badge>;
}
